






















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

// @ts-ignore: webkitAudioContext is not known
const audioCtx = new (window.AudioContext || window.webkitAudioContext)();

@Component
export default class RoomSettings extends Vue {
  @Prop({ required: false, default: null })
  currentStream!: MediaStream | null;
  @Prop({ required: true })
  name!: string;

  @Prop({ default: "Save Settings" })
  submitText!: string;

  mediaDevices: Array<MediaDeviceInfo> = [];
  nameVal = "";
  microphoneDevice: string | null = null;
  videoDevice: string | null = null;
  resultStream: MediaStream | null = null;

  analyzer: AnalyserNode | null = null;
  source: AudioNode | null;

  audioLevel = 0;

  async created() {
    this.resultStream = this.currentStream;
    if (this.resultStream) {
      this.microphoneDevice = this.resultStream.getAudioTracks()[0].getSettings().deviceId;
      this.videoDevice = this.resultStream.getVideoTracks()[0].getSettings().deviceId;
      this.mediaDevices = await navigator.mediaDevices.enumerateDevices();
    }
  }

  async mounted() {
    this.nameVal = this.name;
    let result;
    if (!this.resultStream) {
      result = await navigator.mediaDevices
        .getUserMedia({
          video: true,
          audio: true,
        })
        .catch(err => {
          console.log(err);
          return null;
        });
    }
    if (result) {
      this.microphoneDevice = result.getAudioTracks()[0].getSettings().deviceId;
      this.videoDevice = result.getVideoTracks()[0].getSettings().deviceId;
      this.mediaDevices = await navigator.mediaDevices.enumerateDevices();
      this.resultStream = result;
    }
  }

  async changeMedia() {
    this.resultStream.getTracks().forEach(t => t.stop());
    const newStream = await navigator.mediaDevices
      .getUserMedia({
        video: { deviceId: { exact: this.videoDevice } },
        audio: { deviceId: { exact: this.microphoneDevice } },
      })
      .catch(err => {
        console.log(err);
        return this.resultStream;
      });
    this.resultStream = newStream;
  }

  @Watch("resultStream")
  resultStreamChanged(newStream: MediaStream | null, oldStream: MediaStream | null) {
    if (!newStream) {
      return;
    }
    if (oldStream && oldStream !== this.currentStream) {
      oldStream.getTracks().forEach(track => {
        track.stop();
      });
    }
    (this.$refs.preview as HTMLMediaElement).srcObject = newStream;
    (this.$refs.preview as HTMLMediaElement).load();
    if (!this.analyzer) {
      audioCtx.resume();
      this.analyzer = audioCtx.createAnalyser();
      const bufferLength = this.analyzer.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);
      const prev = [0, 0, 0];
      const draw = () => {
        if (!this.analyzer) {
          return;
        }

        requestAnimationFrame(draw);
        if (!this.source) {
          return;
        }
        this.analyzer.getByteTimeDomainData(dataArray);
        let max = 0;
        dataArray.forEach(s => {
          const datum = Math.abs((s - 128) / 128) * 100;
          if (datum > max) {
            max = datum;
          }
        });
        prev.shift();
        prev.push(max);
        this.audioLevel = prev.reduce((p, v) => p + v, 0) / prev.length;
      };

      draw();
    } else if (this.source) {
      this.source.disconnect(this.analyzer);
    }
    this.source = audioCtx.createMediaStreamSource(this.resultStream);
    this.source.connect(this.analyzer);
  }

  get microphoneDevices() {
    const result: Record<string, MediaDeviceInfo> = {};
    this.mediaDevices.forEach(d => {
      if (d.kind === "audioinput") {
        result[d.deviceId] = d;
      }
    });
    return result;
  }

  get videoDevices() {
    const result: Record<string, MediaDeviceInfo> = {};
    this.mediaDevices.forEach(d => {
      if (d.kind === "videoinput") {
        result[d.deviceId] = d;
      }
    });
    return result;
  }

  submit() {
    this.$emit("submit", this.nameVal, this.resultStream);
  }

  beforeDestroy() {
    this.analyzer = null;
  }
}
